var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":_vm.title,"size":"lg","id":"article-variants","hide-footer":""}},[(_vm.addresses.length)?_c('variants-stock'):_vm._e(),_c('article-properties'),_c('article-variants')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }